<template>
  <div class="w-full sm:max-w-368 px-16 sm:px-0">
    <slot />
    <form class="flex flex-col mt-24 md:mb-4" @submit.prevent="submitForm">
      <h1 class="text-h3 mb-16">{{ selectedCategoryTitle }}—great! Which ages is your Adventure for?</h1>
      <h2 class="text-body">Think about who’ll love your Adventure the most</h2>
      <Card class="mt-24 p-0 sm:p-24 sm:shadow-md sm:h-auto bg-transparent sm:bg-grey-background-subdued" :elevation="0">
        <ul>
          <li v-for="ageRange in ageRanges" :key="ageRange.id">
            <Checkbox
              :key="ageRange.id"
              v-model="ageRangesSelected"
              :label-name="ageRange.optionText"
              :checkbox-id="`${ageRange.id}`"
              :value="ageRange.id"
            />
          </li>
        </ul>
        <StickyButton :value="isEdit ? 'Save' : 'Next'" type="submit" />
      </Card>
    </form>
  </div>
</template>

<script lang="ts">
// components
import Checkbox from '../../../components/checkbox/Checkbox.vue';
import Card from '../../../components/card/Card.vue';
import StickyButton from '../../../components/sticky_button/StickyButton.vue';

export default {
  name: 'AgeRange',
  components: { Checkbox, Card, StickyButton },
  props: {
    adventureMetaData: {
      default: () => {},
      type: Object,
    },
    isEdit: {
      default: false,
      type: Boolean,
    },
  },
  data(): any {
    return {
      selectedCategoryTitle: this.$store.getters['adventures/adventureDraft'].adventureCategoryName,
      ageRangesSelected: this.$store.getters['adventures/adventureDraft'].ageRangeIds,
      ageRangeText: this.$store.getters['adventures/adventureDraft'].ageRangeText,
    };
  },
  computed: {
    ageRanges(): string[] {
      return this.adventureMetaData?.categories?.[0].ageRanges || [];
    },
  },
  methods: {
    submitForm() {
      if (this.ageRangesSelected.length === 0) {
        this.$emit('alert', 0, 'This question is required.');
        this.scrollToTop();
      } else {
        this.setAgeRanges();
      }
      return false;
    },
    getAgeRangeText(): string {
      const ranges = this.ageRangesSelected
        .sort()
        .map((id: number) => this.adventureMetaData.categories[0]?.ageRanges.find((age: any) => age.id === id));
      const min = ranges[0]?.minRange;
      const max = ranges[ranges.length - 1]?.maxRange || `${ranges[ranges.length - 1]?.minRange}+`;

      if (min === 11) return '11+';
      if (ranges.length === 2 && min === 3 && max === '11+') return '3–5 and 11+';
      return `${min}–${max}`;
    },
    async setAgeRanges() {
      await this.$store.dispatch('adventures/updateStore', {
        ageRangeIds: this.ageRangesSelected,
        ageRangeText: this.getAgeRangeText(),
      });
      this.$router.push({
        path: this.isEdit ? `/adventures/${this.$store.getters['adventures/adventureId']}/edit` : '/adventures/new/description',
      });
    },
    scrollToTop() {
      window.scrollTo(0, 0);
    },
  },
};
</script>
